import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GetTenantChannelInfoByUserDocument, GetCurrentUserIdDocument } from 'graphql-query-contracts';
import { convertToUUID } from 'uuid-encoding';

export interface TenantInfo {
  id: string;
  name: string;
}

export function useTenantInfo(channelId?: string) {
  const { data: currentUserData } = useQuery(GetCurrentUserIdDocument);

  const userId = currentUserData?.me?.user?._id;
  const convertedUserId = userId ? convertToUUID(userId) : null;
  const convertedChannelId = channelId ? convertToUUID(channelId) : null;

  const { data: tenantChannelsData } = useQuery(
    GetTenantChannelInfoByUserDocument,
    {
      skip: !convertedUserId || !convertedChannelId,
      variables: {
        userId: convertedUserId || '',
        channelId: convertedChannelId || '',
      },
    }
  );

  const tenantChannels = tenantChannelsData?.tenantChannelsByUser;

  return useMemo<TenantInfo | undefined>(() => {
    if (!tenantChannels || tenantChannels.length !== 1) {
      return undefined;
    }

    return {
      id: tenantChannels[0]?.id ?? '',
      name: tenantChannels[0]?.name ?? '',
    };
  }, [tenantChannels]);
}
